import { StatusCodes } from 'src/Libs/http-status-codes'
import { AuthFetchWithResponse } from 'src/Types/api'
import { GetGridAndSystemProtectionDto } from '../types/get-grid-and-system-protection.dto'
import { GridAndSystemProtectionModel } from '../types/grid-and-system-protection.model'
import { fromGetDtoToModel } from './transformers'

export const getGridAndSystemProtectionSettings = async (
  storageId: string | null | undefined,
  authFetch: AuthFetchWithResponse
): Promise<GridAndSystemProtectionModel | null> => {
  if (!storageId) return null
  try {
    const response = await authFetch<GetGridAndSystemProtectionDto>({
      path: `storages/${storageId}/hardware/protection`,
    })

    if (response.status === StatusCodes.OK) return fromGetDtoToModel(response.data)
    else throw new Error(`Unexpected response status: ${response.status}`)
  } catch (error) {
    console.error('Failed to fetch grid and system protection settings: ' + (error as Error).message)
    return null
  }
}
